import React from 'react'

import './style.scss'

export default function Footer() {
   return (
      <footer>
         <p>julgandomusica.com &copy; 2021 All Rights Reserved</p>
         <p>Designed and Made by  
            <a href="https://github.com/ryanmattos" target="_blank" rel="noreferrer">Ryan Matos</a>
         </p>
      </footer>
   )
}